var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaTxtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.058,
    viewBox: "0 0 18 18.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.046 -1.308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.154,2H5.631A1.631,1.631,0,0,0,4,3.631V16.677a1.631,1.631,0,0,0,1.631,1.631h9.785a1.631,1.631,0,0,0,1.631-1.631V6.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,2V6.892h4.892",
    transform: "translate(-1.846)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.336,
    transform: "translate(7.355 11.21)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.336,
    transform: "translate(7.355 14.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.631,9H8",
    transform: "translate(-0.738 -1.292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaTxtIcon);
export default __webpack_public_path__ + "static/media/media-txt-icon.37e1e303fc10ed9041902118c85264d7.svg";
export { ForwardRef as ReactComponent };